$(function() {
  // Watchlist slider
  $('#js-watchlist-slider').owlCarousel({
    autoplay: false,
    autoplaySpeed: 0.35,
    loop: false,
    rewind: false,
    navText: ['', ''],
    navContainerClass: 'df-owl__nav df-owl__nav--secondary',
    navClass: ['df-owl__nav__prev df-owl__nav__prev--secondary', 'df-owl__nav__next df-owl__nav__next--secondary'],
    navElement: 'div',
    navSpeed: 0.35,
    dotsClass: 'df-owl__dots df-owl__dots--secondary',
    dotClass: 'df-owl__dots__item df-owl__dots__item--secondary',
    stagePadding: 0,
    nav: true,
    responsive: {
      0: {
        items: 1,
        margin: 20,
        autoWidth: true,
        dots: true,
      },
      768: {
        items: 3,
        margin: 30,
        autoWidth: true,
        dots: false,
      },
      992: {
        items: 3,
        margin: 30,
        autoWidth: true,
        dots: false,
      },
      1200: {
        items: 4,
        margin: 30,
        autoWidth: false,
        dots: false,
      }
    },
  });

  // Main slider
  $("#js-main-slider").owlCarousel({
    autoplay: true,
    autoplaySpeed: 0.7,
    autoplayHoverPause: true,
    animateOut: 'fadeOut',
    loop: true,
    navText: ["", ""],
    navContainerClass: "df-owl__nav df-owl__nav--primary",
    navClass: ["df-owl__nav__prev", "df-owl__nav__next"],
    navElement: "div",
    navSpeed: 0.7,
    dots: true,
    dotsClass: "df-owl__dots df-owl__dots--secondary",
    dotClass: "df-owl__dots__item df-owl__dots__item--secondary",
    items: 1,
    responsive: {
      0: {
        nav: false,
      },
      768: {
        nav: false,
      },
    },
  });

  // Articles slider
  $('#js-articles-slider').owlCarousel({
    autoplay: false,
    // autoplaySpeed: 0.35,
    loop: true,
    rewind: true,
    navText: ['', ''],
    navContainerClass: 'df-owl__nav df-owl__nav--secondary',
    navClass: ['df-owl__nav__prev df-owl__nav__prev--secondary', 'df-owl__nav__next df-owl__nav__next--secondary'],
    navElement: 'div',
    // navSpeed: 0.35,
    dotsClass: 'df-owl__dots df-owl__dots--secondary',
    dotClass: 'df-owl__dots__item df-owl__dots__item--secondary',
    // stagePadding: 0,
    nav: true,
    // slideTransition: 'fade',
    // animateOut:'slideOutDown',
    // animateIn:'slideInDown',
    responsive: {
      0: {
        items: 1,
        margin: 20,
        autoWidth: true,
        dots: true,
      },
      768: {
        items: 3,
        margin: 20,
        autoWidth: true,
        dots: false,
      },
      992: {
        items: 3,
        margin: 30,
        autoWidth: true,
        dots: false,
      },
      1200: {
        items: 4,
        margin: 30,
        autoWidth: false,
        dots: false,
      }
    },
  });

  $('#js-articles-slider .df-owl__nav__next df-owl__nav__next--secondary').on('click', function() {
    // slider animation
    $('#js-articles-slider').trigger('next.owl.carousel');
  });
  
  $('#js-articles-slider .df-owl__nav__prev df-owl__nav__prev--secondary').on('click', function() {
    // slider animation
    $('#js-articles-slider').trigger('prev.owl.carousel');
  });
});